import useScreenSize, { BREAKPOINTS } from './useScreenSize.js';

const useIsSmallScreen = () => {
  const { width } = useScreenSize();
  return width >= BREAKPOINTS.SM;
};

export default useIsSmallScreen;
